import { useEffect } from 'react';

const useTitle = title => {
  useEffect(() => {
    document.title = title || '';

    const faviconElement = document.querySelector('link[rel="icon"]');

    if (faviconElement) {
      faviconElement.setAttribute('href', '/userapp/favicon_brity.ico');
    } else {
      const linkElement = document.createElement('link');
      linkElement.rel = 'icon';
      linkElement.href = '/userapp/favicon_brity.ico';

      document.head.appendChild(linkElement);
    }
  }, []);
};

export default useTitle;
